window.guidelineFirst = 1;
// set_scroll_point_in = 200;

if (typeof set_scroll_point !== "undefined") {
    //Do something since x is defined.
    set_scroll_point_in = set_scroll_point;
}else{
    set_scroll_point_in = 200;
    set_scroll_height =0;
}

window.maxY = 0; 
window.initGuideline = function() {
    // Reset height
    $('#guideline, #guideline:before').css('height', 0);

    var $w = $(window);
    var _y = 0;

    var windowHeight = $(document).height();
    // if(typeof set_scroll_height !== "undefined"){
    //     maxY = windowHeight - set_scroll_height;
    // }else{
    //     maxY = windowHeight - 936;
    // }
    maxY = windowHeight - 960;

    var startGuidelineY = $(window).height() - 200;
    var timeout;

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    // Adjust position for IE
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        maxY = maxY - 3;
    }

    $('#guideline, #guideline:before').animate({
        height: maxY + 70
    });
    
    if (window.guidelineFirst === 1) {
        timeout = 3500;
    } else {
        timeout = 1;
    }    

    setTimeout(function() {
        $('#guideline .bar, #guideline .scroll-down, #guideline .back-to-top').fadeIn();

        $(window).on('scroll', function(e) {
            var st = $w.scrollTop();
            _y = st;

            var ratio = st/10 + 120;
            var newY = (_y + ratio) <= maxY - 40 ? (_y + ratio) : maxY - 40;

            if (newY > startGuidelineY) {
                $('#guideline .bar').css('top', newY);
                $('#guideline .scroll-down').addClass('hide');
            }
            else {
                $('#guideline .bar').css('top', startGuidelineY-110);
                $('#guideline .scroll-down').removeClass('hide');
            }
        });
    }, timeout);

    var st = $w.scrollTop();
    var ratio = st/10 + 120;
    var newY = (st + ratio) <= maxY ? (st + ratio) : maxY;
    $('#guideline .bar').css('top', (newY > startGuidelineY) ? newY - 40 : startGuidelineY - 110);
    $('#guideline .scroll-down').css('top', startGuidelineY + 80 - 110);

    $('#guideline').on('click', '.back-to-top', function() {
        // var h_ = ($('#guideline').height() * 0.15);
        $("html, body").animate({scrollTop: 0}, 100);
    });

    $('body').on('click', '.back-to-top-mb .element', function() {
        // $("html, body").animate({scrollTop: 0}, 100);
    });
}

// Guideline
window.addEventListener('load', function() {
    var f = navigator.userAgent.search("Firefox");
    
    if (f) {
        // firefox
        // create an Observer instance
        const resizeObserver = new ResizeObserver(entries => {
            window.initGuideline();
            window.guidelineFirst = 0;
        })
        
        // start observing a DOM node
        resizeObserver.observe(document.body)
    } else {
        setTimeout(window.initGuideline(), 3500);
    }

    window.guidelineFirst = 0;
});




// WEBPACK FOOTER //
// ./resources/js/guideline.js